import PropTypes from "prop-types"

import { cn } from "styles/utils"

const Badge = ({ className, label, variant }) => {
  return (
    <span
      className={cn(
        "z-1 bg-polar text-12 leading-14 desktop:left-20 desktop:top-20 absolute left-8 top-8 inline-flex items-center justify-center px-8 py-2 font-semibold text-black",
        variant === "sale" && "bg-sale text-white",
        variant === "christmas" && "bg-emerald text-white",
        variant === "sky" && "bg-sky text-white",
        variant === "deal" && "bg-[#FBE3E3]",
        variant === "kid" && "bg-[#DCD2E7]",
        variant === "mday" && "bg-light-pink",
        variant === "vday" && "bg-[#FCF2F2]",
        variant === "xmas_delivery" && "bg-garnet text-white",
        variant === "lee_fiori" && "bg-[#EEEDE6]",
        variant === "best_deal" && "bg-black-print text-white",
        className
      )}
    >
      {label}
    </span>
  )
}

Badge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.string,
}

export default Badge
